<template>
  <div>
    <card hidden>
      <h6 class="text-center">Selecionar imagem</h6>
      <div class="row m-1">
        <div class="m-1" v-for="image in shownImages">
          <img :src="image.url_imagem" class="image-add-select" :alt="image.descricao" @click="updateSelectedImage(image)">
        </div>
      </div>
    </card>

    <card hidden card-body-classes="d-flex flex-wrap">
      <div class="w-100 d-flex">
        <label for="formFileMultiple" class="form-label mr-2">Pesquisar: </label>
        <input class="flex-grow-1" type="text" v-model="query">
      </div>
      <button class="btn btn-primary w-100" @click="searchImages">Pesquisar</button>
    </card>

    <card card-body-classes="d-flex flex-wrap">
      <h6 class="w-100 text-center">Image Selecionada</h6>
      <div class="flex-grow-1 m-4">
        <img :src="selectedImage.url_imagem" class="image-add-selected" :alt="selectedImage.descricao" style="display: block;margin-left: auto; margin-right: auto">
      </div>
      <div class=" d-flex flex-wrap flex-grow-1 justify-content-center align-items-center">
        <input type="file" accept="image/*" class="form-control" ref="addIconInput" @change="setSelectedImageToUpload" single>

        <div class="w-100 d-flex flex-wrap m-2">
          <label for="formFileMultiple" class="form-label mr-2">Descrição: </label>
          <input class="flex-grow-1" type="text" v-model="selectedImage.descricao">
          <button class="btn btn-danger w-100" @click="uploadImage">Importar</button>
        </div>
      </div>
    </card>

  </div>
</template>

<script>

import { search } from "@/services/ProductImageSearchService";
import { uploadIcon } from "@/services/MenuAiService";
import { dataURItoBlob, store } from "@/services/UploadService";

export default {
  components: {},

  data() {
    return {
      defaultImg: "https://cdn-production.yooga.com.br/120201112170357YBpu1ClGH.png",
      shownImages: [],
      query: "",
      selectedImage: { url_imagem: "https://cdn-production.yooga.com.br/120201112170357YBpu1ClGH.png", descricao: "" }
    }
  },
  methods: {
    setSelectedImageToUpload() {
      const file = this.$refs.addIconInput.files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.selectedImage.url_imagem = e.target.result;
        console.log(this.selectedImage.url_imagem)
      };
      reader.readAsDataURL(file);
    },
    searchImages() {
      const loader = this.$loading.show();
      search(this.query).then(res => {
        this.shownImages = res.data.data
        loader.hide();
      }).catch(err => {
        loader.hide();
        this.$swal({
          title: "Erro ao buscar imagens",
          text: err,
        });
      });
    },
    updateSelectedImage(image) {
      this.selectedImage = image;
      this.$refs.addIconInput.value = null;
    },
    uploadImage() {
      if(this.selectedImage.url_imagem === this.defaultImg)
        return this.$swal("Selecione uma imagem");

      if(this.selectedImage.descricao === "")
        return this.$swal("Informe uma descrição");

      // New file
      if (this.selectedImage.url_imagem.startsWith("data:")) {
        const loader = this.$loading.show();

        const formData = new FormData();
        formData.append('file', dataURItoBlob(this.selectedImage.url_imagem));

        store(formData).then(res => {
          this.selectedImage.url_imagem = res.data.url;

          loader.hide();
          this.addEmbedding();
        }).catch(err => {
          loader.hide();
          return this.$swal({
            title: "Erro ao importar imagem",
            text: "Erro ao salvar no CDN: " + err,
          });
        });

        // Already uploaded file
      } else this.addEmbedding();
    },
    addEmbedding() {
      const loader = this.$loading.show();
      return uploadIcon(this.selectedImage.url_imagem, this.selectedImage.descricao).then(() => {
        loader.hide();
        this.$eventService.track("dashboard-admin-menu-ai-added-new-icon");
        this.$swal("Imagem importada com sucesso");
      }).catch(err => {
        loader.hide();

        this.$swal({
          title: "Erro ao importar imagem",
          text: err,
        });
      });
    }
  },
}
</script>

<style>
.image-add-selected {
  outline: 3px solid grey;
  width: 300px;
  height: 300px;
}

.image-add-select {
  width: 60px;
  height: 60px;
}

.image-add-select:hover {
  outline: 2px solid #ccc;
  cursor: pointer;
}
</style>
